import request from '@/api/axios';
const uploadFileApply = (params) => {
    //上传申请
    params.isApi2 = true
    return request({
        url: "/open/center/oss/fileUploadApply",
        method: "post",
        data: params,
    });
}
const uploadFile = (params: object) => {
    params.isApi2 = true
    return request({
        url: "/open/center/oss/fileUpload",
        method: 'post',
        data: params,
    });
}
const uploadCallback = (params) => {
    //上传文件业务状态回调
    params.isApi2 = true
    return request({
        url: "/open/center/oss/fileUploadBizCallback",
        method: "post",
        data: params,
    });
}
const fileDelete = (params) => {
    //删除文件
    params.isApi2 = true
    return request({
        url: "/open/center/oss/fileDelete",
        method: "post",
        data: params,
    });
}


let OssApi = {
    uploadFileApply,
    uploadCallback,
    uploadFile,
    fileDelete,
}
export default OssApi;
